import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import TextIconButton from "@components/TextIconButton";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";
import { PhotoAlbum } from '@mui/icons-material';

const Badge = styled.div`
  background: #e34b64ff;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  color: #ffffffff;
  border-radius: 40px;
  padding: 0 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 26px;
`;

export interface AlbumToolbarProps {
  photoCount: number;
  readOnly: boolean;
  counter: number;
  onRemove: () => void;
  onSelect: () => void;
  onSetAsCover: () => void;
}

const AlbumToolbar: FC<AlbumToolbarProps> = ({
  photoCount,
  readOnly,
  counter,
  onRemove,
  onSelect,
  onSetAsCover,
}) => {
  const { t } = useTranslation();

  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      flexWrap="wrap"
      justifyContent="space-between"
    >
      <Stack flexDirection="row" alignItems="center" gap="48px">
        <Stack flexDirection="row" alignItems="center" gap="8px">
          <Typography
            fontSize="14px"
            lineHeight="22px"
            fontWeight="700"
            color="#171A1FFF"
          >
            {t("editAlbum.toolbar.counterLabel")}
          </Typography>
          <Badge>{photoCount}</Badge>
        </Stack>
        <Stack flexDirection="row" alignItems="center" gap="8px">
          {!readOnly &&
            <TextIconButton
              text={
                t("editAlbum.toolbar.removeButton") +
                (counter > 0 ? ` (${counter})` : "")
              }
              icon={ClearIcon}
              variant="contained"
              color="warning"
              onClick={onRemove}
              disabled={!counter}
            />
          }
          <TextIconButton
            text={
              t("editAlbum.toolbar.setAsCover")
            }
            icon={PhotoAlbum}
            variant="contained"
            onClick={onSetAsCover}
            disabled={counter !== 1}
          />
        </Stack>
      </Stack>

      {!readOnly &&
          <TextIconButton
            text={t("editAlbum.toolbar.selectButton")}
            icon={AddIcon}
            variant="outlined"
            onClick={onSelect}
          />
      }
    </Stack>
  );
};

export default AlbumToolbar;
